const triggerB2BUpdate = () => {
    if (window.BSS_B2B?.nt) {
        window.BSS_B2B.nt.initFunction();
        document.dispatchEvent(new Event("bss_b2b:dom_ready"));
        document.dispatchEvent(new Event("DOMContentLoaded"));
    }
};

let b2bCartUpdateTimer;
const debounceB2BUpdate = (delay = 800) => {
    clearTimeout(b2bCartUpdateTimer);
    b2bCartUpdateTimer = setTimeout(triggerB2BUpdate, delay);
};

document.addEventListener('click', (e) => {
    const isRemoveBtn = e.target.closest('.cart-item__remove');
    const isQtyBtn = e.target.closest('.cart-item__quantity-button');
    
    if (isRemoveBtn || isQtyBtn) {
        debounceB2BUpdate(800);
    }
});

document.addEventListener('input', (e) => {
    if (e.target.classList.contains('cart-item__quantity-input')) {
        debounceB2BUpdate(1000);
    }
});
